import { getMethodOfInspections } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export function useGetMethodOfInspections(
  tenantId: string,
  isEnabled: boolean
) {
  const { data, status } = useQuery(
    ['methodOfInspections'],
    () => getMethodOfInspections(tenantId),
    {
      enabled: isEnabled,
    }
  );

  return {
    methodOfInspections: data?.data || [],
    methodOfInspectionStatus: status,
  };
}
